import { createContext } from 'react'
import { TLoadingContext } from '../types'

export const defaultLoadingContext: TLoadingContext = [false, () => {}]

export const LoadingContext = createContext<TLoadingContext>(
  defaultLoadingContext
)
